import { Calendar } from 'lucide-react'
import { DATE_TABS, type DateTab, type UseDateRangeReturn } from '../../hooks/useDateRange'
import { cn } from '../../utils/cn'

export function DateRangePicker({
  tab, setTab, customFrom, setCustomFrom, customTo, setCustomTo, tabs,
}: UseDateRangeReturn & { tabs?: DateTab[] }) {
  const shownTabs = tabs ? DATE_TABS.filter((t) => tabs.includes(t.value)) : DATE_TABS
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2">
      <div className="flex items-center gap-0.5 bg-white rounded-xl shadow-card p-1 overflow-x-auto max-w-full">
        {shownTabs.map((t) => (
          <button
            key={t.value}
            onClick={() => setTab(t.value)}
            className={cn(
              'rounded-lg px-2.5 py-1.5 text-xs font-medium transition-colors whitespace-nowrap',
              tab === t.value ? 'bg-brand-500 text-white' : 'text-gray-500 hover:text-gray-800',
            )}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'custom' && (
        <div className="flex items-center gap-2 card py-2 px-3">
          <Calendar className="h-4 w-4 text-gray-400 flex-shrink-0" />
          <input type="date" className="input py-1.5 text-sm w-36" value={customFrom} onChange={(e) => setCustomFrom(e.target.value)} />
          <span className="text-gray-400 text-sm">to</span>
          <input type="date" className="input py-1.5 text-sm w-36" value={customTo} onChange={(e) => setCustomTo(e.target.value)} />
        </div>
      )}
    </div>
  )
}
